import React from 'react'
import Black from '../Video/Backgorund.mp4'
import Carousel from 'react-bootstrap/Carousel'
import {BrowserRouter as Router, Route, Link } from 'react-router-dom'
import Thereturn from '../Pages/thereturn.js'
import Sidescroller from '../Pages/sidescroller.js'
import Adventure from '../Pages/Adventure.js'
import adventure from '../Assets/Adventure capture.PNG'
import side from '../Assets/Side Scroller still.PNG'
import thereturn from '../Assets/The return capture.PNG'
import Container from 'react-bootstrap/Container'




import { MDBCarousel, MDBCarouselCaption, MDBCarouselInner, MDBCarouselItem, MDBView, MDBMask, MDBContainer } from
"mdbreact";

const CarouselPage = () => {
  return (
    <div className="App">
          <video
            autoPlay
            loop
            muted
            style={{
              position: "absolute",
              width: "100%",
              left: "50%",
              top: "75%",
              height: "150%",
              objectFit: "cover",
              transform: "translate(-50%, -50%)",
              zIndex: "-1"
            }}
          >
        <source src ={Black} type="video/mp4" />

        </video>
    
    <MDBContainer>
      <MDBCarousel
      activeItem={1}
      length={3}
      showControls={true}
      showIndicators={true}
      className="z-depth-1"
    >
      <MDBCarouselInner>
        <MDBCarouselItem itemId="1">
          <MDBView>
            <img
              className="d-block w-100"
              img src={adventure}
              alt="First slide"
            />
          <MDBMask overlay="black-light" />
          </MDBView>
          <MDBCarouselCaption>
            <h3 style={{color: 'goldenrod'}} className="h3-responsive">Adventure Level</h3>
            <Link to="/Adventure">View </Link>
          </MDBCarouselCaption>
        </MDBCarouselItem>
        <MDBCarouselItem itemId="2">
          <MDBView>
            <img
              className="d-block w-100"
              img src={side}
              alt="Second slide"
            />
          <MDBMask overlay="black-strong" />
          </MDBView>
          <MDBCarouselCaption>
            <h3 style={{color: 'goldenrod'}} className="h3-responsive">Side Scroller</h3>
            <Link to="/sidescroller">View </Link>
          </MDBCarouselCaption>
        </MDBCarouselItem>
        <MDBCarouselItem itemId="3">
          <MDBView>
            <img
              className="d-block w-100"
              img src= {thereturn}
              alt="Third slide"
            />
          <MDBMask overlay="black-slight" />
          </MDBView>
          <MDBCarouselCaption>
            <h3 style={{color: 'goldenrod'}} className="h3-responsive">The Return</h3>
            <Link to="/thereturn">View </Link>
          </MDBCarouselCaption>
        </MDBCarouselItem>
        <Container>
    <Route path="/Adventure" render={() => <Adventure title={this.state.Adventure} />}/>
    <Route path="/sidescroller" render={() => <Sidescroller title={this.state.sidescroller} />}/>
    <Route path="/thereturn" exact render={() => <Thereturn title={this.state.thereturn} />}/>
    </Container>
      </MDBCarouselInner>
    </MDBCarousel>
    </MDBContainer>
    </div>
    
  );
}

export default CarouselPage;










